Namespace 'Customer.Reports'

class Customer.Reports.ReportOutputFormatDefinition extends Backbone.Model
  getFormat: (type) ->
    if type == 'conversations' then 'csv' else 'xls'
